const lastAction = (state = null, action) => {
    if (
        action.type.includes("subscriptions/internal_probeSubscription") ||
        action.type.includes("executeQuery/fulfilled")
    ) {
        const { meta, ...rest } = action;
        return rest;
    }
    return action;
};

export default lastAction;
